import React, { useEffect, useContext } from "react";
import { DatePicker } from "antd";
import { AppContext } from "../../context";
import moment from "moment";
import { FIELD_MARGIN_RIGHT, FIELD_WIDTH } from "../../config/layoutConfig";

const { RangePicker } = DatePicker;
const dateFormat = "YYYY-MM-DD";

const DateRangePicker = ({ dates }) => {
  // const { range, setRange } = useContext(AppContext);
  const info = useContext(AppContext);

  // useEffect(() => {
  //   console.log("typeof setReserveData :>> ", typeof setReserveData);
  //   setRange(
  //     // REMOVER - apenas serve para ter as datas pré-definidas durante o desenvolvimento
  //     // { startDate: moment(), endDate: moment() }
  //   );
  // }, []);

  const handleCalendarChange = (dateRange) => {
    if (dateRange) {
      // account for dateRange[0] > dateRange[1]
      if (dateRange[0] > dateRange[1]) {
        let auxDate = dateRange[0];
        dateRange[0] = dateRange[1];
        dateRange[1] = auxDate;
      }
      info.setLodge({
        ...info.lodge,
        checkIn: dateRange[0],
        checkOut: dateRange[1],
      });
    } else {
      // date range is empty
      info.setLodge({
        ...info.lodge,
        checkIn: null,
        checkOut: null,
      });
    }
  };

  return (
    <>
      <RangePicker
        disabledDate={(current) => current && current < moment()}
        value={
          // (dates?.length && dates) ||
          [info.lodge?.checkIn, info.lodge?.checkOut]
        }
        onChange={handleCalendarChange}
        style={{
          width: FIELD_WIDTH,
          marginRight: FIELD_MARGIN_RIGHT,
        }}
        bordered={false}
        separator={null}
        suffixIcon={null}
        size="small"
        placeholder={["CHECK-IN", "CHECK-OUT"]}
      ></RangePicker>
    </>
  );
};

export default DateRangePicker;
